// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tip-module-tip {
  padding: 15px;
  border-radius: 5px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 10px;
  background-color: var(--border);
}

.Tip-module-tip > svg {
  width: 30px;
  height: 30px;
  fill: var(--text);
  flex-shrink: 0;
}

.Tip-module-warning {
  background-color: rgba(255, 136, 0, 0.12);
}

.Tip-module-warning > svg {
  fill: rgb(255, 136, 0);
}

.Tip-module-error {
  background-color: rgba(255, 72, 0, 0.137);
}

.Tip-module-error > svg {
  fill: rgb(255, 72, 0);
}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/Tip/Tip.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".tip {\r\n  padding: 15px;\r\n  border-radius: 5px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  width: 100%;\r\n  gap: 10px;\r\n  background-color: var(--border);\r\n}\r\n\r\n.tip > svg {\r\n  width: 30px;\r\n  height: 30px;\r\n  fill: var(--text);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.warning {\r\n  background-color: rgba(255, 136, 0, 0.12);\r\n}\r\n\r\n.warning > svg {\r\n  fill: rgb(255, 136, 0);\r\n}\r\n\r\n.error {\r\n  background-color: rgba(255, 72, 0, 0.137);\r\n}\r\n\r\n.error > svg {\r\n  fill: rgb(255, 72, 0);\r\n}"],"sourceRoot":""}]);
// Exports
export var tip = `Tip-module-tip`;
export var warning = `Tip-module-warning`;
export var error = `Tip-module-error`;
export default ___CSS_LOADER_EXPORT___;
